// 手机号正则验证
export function validatePhone(rule, value, callback) {
	let reg = /^1[3-9]\d{9}$/
	if (value === '') {
		callback(new Error('请填写手机号'));
	} else if (!reg.test(value)) {
		callback(new Error('请填写正确的手机号'));
	} else {
		callback();
	}
};
export function validateEmail(rule, value, callback) {
	let reg = /^\w+((.\w+)|(-\w+))+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/;
	if (value === '') {
		callback(new Error('请填写邮箱'));
	} else if (value && !reg.test(value)) {
		callback(new Error('邮箱格式有误'));
	} else {
		callback()
	}
};

export function validateIdCard(rule, value, callback) {
	let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
	if (value === '') {
		callback(new Error('请输入身份证号'));
	} else if (!reg.test(value)) {
		callback(new Error('身份证号格式有误'));
	} else {
		callback()
	}
};